import { render, staticRenderFns } from "./chinh-sach-van-chuyen-giao-nhan.vue?vue&type=template&id=1162dee0&"
import script from "./chinh-sach-van-chuyen-giao-nhan.vue?vue&type=script&lang=js&"
export * from "./chinh-sach-van-chuyen-giao-nhan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports